import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useInventoryStore } from '../../store/inventoryStore'
import { updateCategory } from '../../utils/updateCategory'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useUpdateCategoryMutation = (onSuccess?: () => void) => {
  const editCategory = useInventoryStore((state) => state.updateCategory)

  return useMutation({
    mutationFn: updateCategory,
    onSuccess: ({ message, category }) => {
      editCategory(category)
      toast.success(message || 'Category updated successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(
        error,
        'An error occurred while updating the category.',
      )
    },
  })
}
